module.exports = "/_next/static/media/d4e894ccf4d68799ea74f7933d0b1350.png";